import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Route, BrowserRouter as Router, Switch, useHistory } from "react-router-dom";
import "./App.css";
import { loginRequest, msalConfig } from "./authConfig";
import Footer from "./function-components/Footer";
import Navbarmenu from "./function-components/Navbarmenu";
import { PageLayout } from "./function-components/PageLayout";
import Reviews from "./function-components/Reviews";
import SearchNav from "./function-components/Searchnav";
import CoursesUpload from "./function-components/UploadCourses/CoursesUpload";
import AutomationEngineering from "./pages/AutomationEngineering";
import BackendEngineering from "./pages/BackendEngineering";
import Dashboard from "./pages/Dashboard";
import DataEngineering from "./pages/DataEngineering";
import Domains from "./pages/Domains";
import FAQ from "./pages/FAQ";
import FullStackEnginner from "./pages/FullStackEnginner";
import Home from "./pages/Home";
import Sponsors from "./pages/Sponsors";
import UserMaintenance from "./pages/UserMaintenancePage";
import WebDeveloper from "./pages/WebDeveloper";
import { getUserMaintanenceData } from "./Redux/UserMaintanence";
import { CustomNavigationClient } from "./utils/NavigationClient";
// import { useDispatch } from "react-redux";
import axios from "axios";
import { useSelector } from "react-redux";
import AnalyticsPage from "./function-components/AnalyticsPage";
import ProtectedRoute from "./function-components/ProtectedRoute.jsx";
import { LogoImagesParams } from "./imagesData/ImagesData.js";
import baseUrl from "./utils/Constants.js";

function App({ pca }) {
 const history = useHistory();
 const navigationClient = new CustomNavigationClient(history);
 pca.setNavigationClient(navigationClient);

 const dispatch = useDispatch();
 // useState(()=>{
 //   dispatch(uploadCourses())
 // })
 return (
  <MsalProvider instance={pca}>
   <PageLayout>
    <div container justifyContent="center">
     <Pages />
    </div>
   </PageLayout>
  </MsalProvider>
 );
}
function Pages() {
 const msalInstance = new PublicClientApplication(msalConfig);
 const { instance,accounts } = useMsal();
 const activeAccount = instance.getActiveAccount();
 const [imageUrls, setImageUrls] = useState({});
 const query = `params=${encodeURIComponent(JSON.stringify(LogoImagesParams))}`;
 const userData = useSelector((state) => state.userRoles.UserMaintanenceData);
 let loggedInEnterpriseId = "";
   useEffect(() => {
    if (accounts.length > 0) {
      // ✅ User is logged in → start timer
      const timer = setTimeout(() => {
        instance.logoutRedirect();
      }, 15 * 60 * 1000);

      return () => clearTimeout(timer); // cleanup
    }
  }, [accounts]);
 if (activeAccount) {
  loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
 }

 const adminUser = userData
  ?.filter((user) => user.Admin === "yes")
  .map((user) => user.Enterprise_ID);
 const currentUser = userData?.find(
  (item) => item.Enterprise_ID === loggedInEnterpriseId,
 );
 const [isContributor, setIsContributer] = useState(false);
 const hasAccess = (role) => currentUser?.[role]?.toLowerCase() === "yes";
 const allowedUsersForContibution = [
  "aluru.akash",
  "ankur.e.mishra",
  "h.srinivasan",
  "jeevadharani.ramanan",
  "arpita.m.singh",
  "uma.rani.battu",
  "varsha.a.tyagi",
  "aditya.c.soni",
  "deepali.raina",
  "ashwin.deshpande",
  "reshmi.haridas.m",
  "nikita.apte",
  "chandini.vardhanapu"
 ];

 const isAdmin = adminUser?.includes(loggedInEnterpriseId);
 useEffect(() => {
  if (activeAccount) {
   fetchAccessToken();
   setIsContributer(allowedUsersForContibution.includes(loggedInEnterpriseId));
  }
 }, [activeAccount]);
 const dispatch = useDispatch();
 useEffect(() => {
  const fetchImageUrls = async () => {
   try {
    const response = await axios.get(`${baseUrl}/images?${query}`);
    setImageUrls(response.data);
   } catch (error) {
    console.error("Error fetching image URLs:", error);
   }
  };

  fetchImageUrls();
  setTimeout(() => {
   dispatch(getUserMaintanenceData());
  }, [1000]);
  dispatch(getUserMaintanenceData());
 }, []);
 const validateToken = async (token) => {
    try {
      // Validate signing algorithm
      const tokenHeaders = JSON.parse(atob(token.split(".")[0]));
      if (tokenHeaders.alg !== "RS256") {
        throw new Error("Invalid signing method detected!");
      }

      // Validate expiration
      const tokenPayload = JSON.parse(atob(token.split(".")[1])); // Decode JWT payload
      const expirationTime = tokenPayload.exp * 1000; // Convert `exp` (seconds) to milliseconds

      if (Date.now() > expirationTime) {
        throw new Error("Token has expired!");
      }

      // If all validations pass successfully
      return true;
    } catch (error) {
      console.error("Token validation failed:", error);
      return false;
    }
  };
 const fetchAccessToken = async () => {
    if (!activeAccount)
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );

    try {
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });
      const accessToken = response.accessToken;

      // Validate the token before storing it
      const isValidToken = await validateToken(accessToken);

      if (isValidToken) {
        sessionStorage.setItem("token", `Bearer ${accessToken}`); // Store token only if validated successfully
      } else {
        throw new Error("Invalid token! Failed to store.");
      }
    } catch (error) {
      console.error("Error fetching access token or validation failed:", error);
      sessionStorage.removeItem("token"); // Clear token on error
    }
  };

 return (
  <>
   <Router basename={"/VodafoneTalentAcademy"}>
    <SearchNav imagesObj={imageUrls?.imageUrl} />
    <Navbarmenu />
    <Switch>
     <Route exact path="/home">
      <Home bannerimg={imageUrls?.imageUrl?.img3} />
     </Route>
     <Route exact path="/faq">
      <FAQ />
     </Route>
     <Route exact path="/Sponsors">
      <Sponsors />
     </Route>
     <ProtectedRoute
      exact
      path="/UserMaintenance"
      component={UserMaintenance}
      isAllowed={isAdmin}
     />
     <Route exact path="/Roles">
      <Domains bannerimg={imageUrls?.imageUrl?.img3} />
     </Route>
     <Route exact path="/Dashboard">
      <Dashboard />
     </Route>
     {/* <Route exact path="/SystemEngineer">
            <DataEngineering bannerimg={imageUrls?.imageUrl?.img3}/>
          </Route> */}
     <ProtectedRoute
      exact
      path="/SystemEngineer"
      component={DataEngineering}
      bannerimg={imageUrls?.imageUrl?.img3}
      isAllowed={hasAccess("System_Engineer")}
     />
     {/* <Route exact path="/BackendDeveloper">
            <BackendEngineering bannerimg={imageUrls?.imageUrl?.img3}/>
          </Route> */}
     <ProtectedRoute
      exact
      path="/BackendDeveloper"
      component={BackendEngineering}
      bannerimg={imageUrls?.imageUrl?.img3}
      isAllowed={hasAccess("Backend_Developer")}
     />
     {/* <Route exact path="/WebDeveloper">
            <WebDeveloper bannerimg={imageUrls?.imageUrl?.img3}/>
          </Route> */}
     <ProtectedRoute
      exact
      path="/WebDeveloper"
      component={WebDeveloper}
      bannerimg={imageUrls?.imageUrl?.img3}
      isAllowed={hasAccess("Web_Developer")}
     />
     {/* <Route exact path="/FullStackEngineering">
            <FullStackEnginner bannerimg={imageUrls?.imageUrl?.img3}/>
          </Route> */}
     <ProtectedRoute
      exact
      path="/FullStackEngineering"
      component={FullStackEnginner}
      bannerimg={imageUrls?.imageUrl?.img3}
      isAllowed={hasAccess("FullStack_Engineer")}
     />
     {/* <Route exact path="/AutomationEngineer">
            <AutomationEngineering bannerimg={imageUrls?.imageUrl?.img3}/>
          </Route> */}
     <ProtectedRoute
      exact
      path="/AutomationEngineer"
      component={AutomationEngineering}
      bannerimg={imageUrls?.imageUrl?.img3}
      isAllowed={hasAccess("Automation_Engineer")}
     />
     <Route exact path="/">
      <Home bannerimg={imageUrls?.imageUrl?.img3} />
     </Route>
     {/* <Route exact path="/admin">

            <Admin />
          </Route> */}
     {/* <Route exact path="/assessment">
    
            {isSubmitted ? <Congrats></Congrats> : <InstructionsContent />}


          </Route> */}

     {/* <Route exact path="/Congrats">
      <Congrats />
     </Route> */}

     {/* <Route exact path="/upload">
            <CoursesUpload />
          </Route> */}
     <ProtectedRoute
      exact
      path="/upload"
      component={CoursesUpload}
      isAllowed={isContributor}
     />
     {/* <Route exact path="/reviews">
            <Reviews />
          </Route> */}
     <ProtectedRoute
      exact
      path="/reviews"
      component={Reviews}
      isAllowed={isContributor}
     />
     <ProtectedRoute
      exact
      path="/AnalyticsPage"
      component={AnalyticsPage}
      isAllowed={isContributor}
     />
    </Switch>
    <Footer imagesObj={imageUrls?.imageUrl} />
   </Router>
  </>
 );
}

export default App;
